// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcu_a bia_wl","LoadingPlaceholder":"bcu_b bia_h","loading-placeholder":"bcu_c"};